import { useEffect, useState } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import liff from '@line/liff';
import { clsx } from 'clsx';

import { Loading, MochiButton, Splash } from '@autopass-web/mochi-component';

import { StepCheckContainer } from '../components/step-check-container';
import { PATHS } from '../const';
import { analyticsService } from '../services/amplitude';
import { sessionStorageController } from '../services/storages';

export function Index() {
  const { replace } = useRouter();
  const [hasCheckedLineLoginStatus, setHasCheckedLineLoginStatus] =
    useState(false);

  const login = async () => {
    analyticsService.introStartClick();

    try {
      await liff.login();
    } catch {
      console.log('liff login failed');
    }
  };

  useEffect(() => {
    if (hasCheckedLineLoginStatus) return;

    const check = async () => {
      const token = sessionStorageController.getToken();
      const isLineLoggedIn = liff.isLoggedIn();

      if (token == null && isLineLoggedIn) {
        await replace(PATHS.AUTH_LINE);
      }

      setHasCheckedLineLoginStatus(true);
    };

    check();
  }, [hasCheckedLineLoginStatus, replace]);

  useEffect(() => {
    analyticsService.introPageview();
  }, []);

  if (!hasCheckedLineLoginStatus) {
    return <Loading />;
  }

  return (
    <StepCheckContainer>
      <Splash init={true} />
      <div
        className={clsx(
          'flex',
          'w-full',
          'h-full',
          'items-center',
          'justify-center',
        )}
      >
        <div
          className={clsx('flex', 'w-full', 'flex-col', 'items-center', 'mx-9')}
        >
          <Image
            src="/onboarding.png"
            width={300}
            height={300}
            alt="onboarding"
          />
          <div
            className={clsx(
              'flex',
              'flex-col',
              'gap-2',
              'items-center',
              'mt-6',
            )}
          >
            <h3 className={clsx('text-[30px]', 'font-medium')}>驗證快速通</h3>
            <div className={clsx('flex', 'flex-col', 'items-center')}>
              <span>輸入車牌，掃描證件</span>
              <span>開啟您的專屬車主旅程</span>
            </div>
          </div>
          <MochiButton
            className={clsx('w-full', 'mt-10')}
            variant="solid-round"
            onClick={login}
          >
            立即開始
          </MochiButton>
        </div>
      </div>
    </StepCheckContainer>
  );
}

export default Index;
